import { useCallback, useEffect, useRef, useState } from 'react'
import { CustomCellEditorProps } from 'ag-grid-react'
import { Box, Button, InputBase } from '@mui/material'
import DatePicker from 'react-datepicker'
import DateTimeVO from '../../../../../vo/DateTimeVO'

export const DateTimeCellEditor = (props: CustomCellEditorProps) => {
  const [value, setValue] = useState<Date | undefined>(
    props.value ? new DateTimeVO(props.value).getValue() : undefined
  )

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const onChange = useCallback((date: Date) => {
    setValue(date)
    props.onValueChange(date ? new DateTimeVO(date).serialize() : undefined)
  }, [])

  const onClose = useCallback(() => {
    const { api } = props
    let focusedCell = api.getFocusedCell()
    api.clearFocusedCell()
    api.setFocusedCell(focusedCell!.rowIndex, focusedCell!.column)
  }, [])

  return (
    <DatePicker
      open={true}
      selected={value}
      dateFormat={'yyyy/MM/dd HH:mm:ss'}
      onChange={onChange}
      onCalendarClose={() => onClose()}
      showTimeInput={true}
      disabledKeyboardNavigation={true}
      shouldCloseOnSelect={false}
      customInput={<InputBase inputRef={inputRef} />}
      calendarContainer={({ className, children }) => (
        <Box className={className}>
          {children}
          <Button
            sx={{
              display: 'block',
              width: '100%',
              borderTop: '1px solid #aeaeae',
              borderRadius: 0,
              backgroundColor: '#f0f0f0',
            }}
            onClick={() => onClose()}
          >
            OK
          </Button>
        </Box>
      )}
    />
  )
}
